import React, {useEffect, useState} from 'react';
import eyeIcon from "../../assests/images/loginUI/br2128px.png";
import eyeCloseIcon from "../../assests/images/loginUI/br1128px.png";
import Querystring from "querystring";
import {firebaseID} from "../../redux/URL";
import {connect} from "react-redux";
import {register, setPublicActionToInitialState, externalLogin} from "../../redux/action/login.action";
import {GoogleLogin} from "react-google-login";
import googleIcon from "../../assests/images/loginUI/google-logo.png";
import FacebookLogin from "react-facebook-login";
import facebookIcon from "../../assests/images/loginUI/facebook-color.png";
import LoadingBbBody from "../boardBand/LoadingBbBody";
import TermsConditons from "../common/TermsConditons";
import backIcon from "../../assests/images/loginUI/back.png";
import {Link} from "react-router-dom";
import ErrorAlert from "../alerts/ErrorAlert";


const NewReg = (props) => {


    const [userName, setUserName] = useState("");
    const [Name, setName] = useState("");
    const [password, setPassword] = useState("");

    const [agree, setAgree] = useState(false);
    const [showTerms, setShowTerms] = useState(false);

    //used to error handling
    const [agreeClass, setAgreeClass] = useState('');
    const [userNameError, setUserNameError] = useState('');
    const [nameError, setNameError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [isPasswordShown, setIsPasswordShown] = useState(false);

    const [isError, setIsError] = useState(false);
    const [error, setError] = useState('');

    const togglePasswordVisiblity = () => {
        setIsPasswordShown(!isPasswordShown)

    }


    useEffect(() => {
        props.setPublicActionToInitialState()
    }, [props.setPublicActionToInitialState]);// eslint-disable-line react-hooks/exhaustive-deps

    const checkStatus = (value) => {
        setUserNameError('')
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let regExp = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im

        if (!value) {
            setUserNameError('User ID cannot be empty')
            return false
        } else if (re.test(value))
            return 'EMAIL'
        else if (value.match(regExp)) {
            return 'MOBILE'
        } else {
            setUserNameError('Enter valid email or mobile number')
            return false
        }


    }

    const submit = () => {
        if (checkStatus(userName) !== false) {
            if (agree) {

                if (password.length < 6) {
                    setPasswordError('Minimum 6 characters')
                } else if (!Name) {
                    setNameError('Name cannot be empty')
                } else {
                    let body = Querystring['stringify']({
                        userName: userName,
                        password: password,
                        Name: Name,
                        userType: checkStatus(userName),
                        firebaseId: firebaseID,
                        appVersion: '1.0',
                        osType: 'iOS',
                        confirmPassword: password
                    })
                    localStorage.setItem('userType', checkStatus(userName))
                    localStorage.setItem('userName', userName)
                    props.register(body, props.history, setError, setIsError, props.setState, props.setRegId)
                }

            } else {
                setAgreeClass('red')
            }

        }


    }

    const responseGoogle = (response) => {

        localStorage.setItem('userType', 'Google')
        localStorage.setItem('userName', response.profileObj.email)
        localStorage.setItem('userImage', response.profileObj.imageUrl)
        let body = Querystring['stringify']({
            provider: 'Google',
            externalAccessToken: response.tokenObj.id_token,
            externalAccessToken2: '',
            firebaseId: firebaseID,
            appVersion: 1.0,
            osType: 'WEB 10',
            channelID: 'WEB'
        })

        props.externalLogin(body, setError, setIsError)
    }

    const responseFacebook = (response) => {

        localStorage.setItem('userType', 'Facebook')

        let body = Querystring['stringify']({
            provider: 'Facebook',
            externalAccessToken: response.accessToken,
            externalAccessToken2: '',
            firebaseId: firebaseID,
            appVersion: 1.0,
            osType: 'Android 10',
            channelID: 'WEB'
        })
        props.externalLogin(body, setError, setIsError)
    }

    if (props.loading)
        return  <LoadingBbBody/>
    if (showTerms)
        return <div style={{height: 500}}>
            <TermsConditons setShowTerms={setShowTerms} setAgree={setAgree}/>
        </div>
    return (
        <div className='auth-container'>
            {isError ? <ErrorAlert error={error} setError={setError} setIsError={setIsError}/> : null}
            <div className='login-form'>
                <div className='titles'>Register</div>
                <div className="input-group">
                    <div className={userNameError ? "input-container error" : "input-container"}>
                        <span className='error-message float-right'>{userNameError}</span>
                        <label className='d-block'>User ID <p className='d-inline red'>*</p></label>
                        <input type='text' className='pLeft' value={userName} placeholder='Email or mobile number'
                               onChange={(e) => {
                                   setUserName(e.target.value.trim())
                                   setUserNameError('')
                               }}/>

                    </div>

                    <div className={nameError ? "input-container error" : "input-container"}>
                        <span className='error-message float-right'>{nameError}</span>
                        <label className='d-block'>Name <p className='d-inline red'>*</p></label>
                        <input type='text' className='pLeft' value={Name} onChange={(e) => {
                            setName(e.target.value)
                            setNameError('')
                        }}
                               placeholder='Full Name'/>

                    </div>

                    <div className={passwordError ? "input-container error" : "input-container"}>

                        <span className='error-message float-right'>{passwordError}</span>
                        <label className='d-block'>Password <p className='d-inline red'>*</p></label>
                        <img src={isPasswordShown ? eyeIcon : eyeCloseIcon} alt='eyeLogo' className='eye'
                             onClick={() => togglePasswordVisiblity()}/>
                        <input type={isPasswordShown ? "text" : "password"} className='pLeft' value={password}
                               placeholder='Minimum 6 characters'
                               onChange={(e) => {
                                   setPassword(e.target.value.trim())
                                   setPasswordError('')
                               }}/>

                    </div>
                </div>

                <div className='d-flex agree'>
                    <input type='checkbox' id="sign" className='sign' checked={agree}
                           onChange={(e) => setAgree(e.target.checked)}/>
                    <label className={agreeClass}>I agree to <strong  onClick={() => setShowTerms(true)}> terms
                        & conditions</strong></label>
                </div>


                <div className='mt-4 clearfix'>
                    <button className='medium blue float-right'
                            onClick={(e) => submit(e)}>{props.loading ? 'Please wait...' : 'Register'}</button>
                </div>


            </div>
            <div className="social">
                <div className="social-container">
                    <div className="box"><p className='line'><span className='or'>Or Sign Up With</span></p>
                        <div className="social-icons clearfix">
                            <GoogleLogin
                                clientId="531709258665-atiep7rt3mrbutfrosms4sset496l026.apps.googleusercontent.com"
                                render={renderProps => (
                                    <button className='google-btn-sign social-icon' onClick={renderProps.onClick}
                                            disabled={renderProps.disabled}><img src={googleIcon} alt={'googleIcon'}/>
                                    </button>
                                )}
                                buttonText="Login"
                                onSuccess={responseGoogle}

                                cookiePolicy={'single_host_origin'}
                            />

                            <FacebookLogin
                                appId="3893048667416465"
                                autoLoad={false}
                                callback={responseFacebook}
                                textButton=''
                                fields="name,email,picture"
                                scope="public_profile,email"
                                cssClass='facebook-btn-sign  social-icon'
                                icon={<img src={facebookIcon} alt={'facebookIcon'}/>}
                                render={renderProps => (
                                    <button className='facebook-btn-sign  social-icon' onClick={renderProps.onClick}/>
                                )}
                            />


                            {/*<button className='apple-btn-sign  social-icon'><img src={appleIcon} alt={'appleIcon'}/></button>*/}

                        </div>
                    </div>
                </div>
            </div>
            <div className='register-container' >
                <p className='register-label'>Already a MySLT user ?</p>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a className='btn-register' onClick={() => props.setState('signin')}>Sign In
                </a>
            </div>

            <Link to={'/promo/buyonline'}>
                <div className='btn-back back' onClick={() => props.setState('signin')}>
                    <img src={backIcon} alt='backLogo' className='back'/>
                    <p>Back to home</p>
                </div>
            </Link>
        </div>

    );
};


const mapStateToProps = state => ({
    loading: state.login.loading,
    error: state.login.error
})

export default connect(mapStateToProps, {register, setPublicActionToInitialState, externalLogin})(NewReg);
